import { render, staticRenderFns } from "./AgendaForm.vue?vue&type=template&id=79745812&"
import script from "./AgendaForm.vue?vue&type=script&lang=js&"
export * from "./AgendaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports